var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSfsync(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4855 5113 c-65 -16 -4745 -1939 -4774 -1962 -110 -86 -102 -266 14 -340 38 -24 152 -47 1162 -231 l1120 -203 204 -1120 c230 -1266 208 -1180 315 -1233 63 -31 125 -29 191 4 50 26 66 45 102 122 78 170 1921 4694 1927 4729 23 141 -119 268 -261 234z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSfsync);
export default __webpack_public_path__ + "static/media/sfsync.5a6d79c94114721980766d957bccc351.svg";
export { ForwardRef as ReactComponent };